import { useState } from "react";
import { LoaderContext } from "./LoaderContext";
import Loader from "../components/Loader";

const LoaderContextProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const showLoader = () => setLoading(true);
  const hideLoader = () => setLoading(false);

  return (
    <LoaderContext.Provider value={{ loading, showLoader, hideLoader }}>
      {children}
      <Loader open={loading} />
    </LoaderContext.Provider>
  );
};
export default LoaderContextProvider;
